import React, { useEffect, useRef, useState } from "react";
import styles from "./scss/leftsidebar.module.scss";
import SavedChatListsLeft from "./savedchat";
import DraftListsLeft from "./draftlist";
import FailedListsLeft from "./failed";
import ArchieveLists from "./archieve";
import UnreadContactLists from "./unread";
import CreateDropDown from "./createdropdown";
import Searchbox from "./searchbox";
import Filterlayer from "./filterlayer";
import Pinchats from "./pinchats";
import Recentchats from "./recentchats";
import {Cookie } from "../../../base/utils";
//import { useLocation } from 'react-router-dom';
import { chats, chatwindowDetails, initialStateModel, leftsideChats, LoginState, recentChatSocketReducerStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";
import { ChatService } from "../../../base/chatService";
import { SearchRecentSocketChat, userInfo,generateChatID } from "../../../base/socketChatService/utils";
import _ from 'lodash';
import Favouritechats from "./favouriteChats";
import { SocketChatService } from "../../../base/socketChatService";
import { useHistory } from "react-router";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import NotificationBottom from "../chatWidgets/notificationBottom";
import NoContent from "../../../shared/widgets/noContent";
import noResult from "../../../styles/images/empty_states/chat_empty_state.svg";
import noResultSearch from "../../../styles/images/empty_states/empty-nofound.svg";
import nodataChatleft from "../../../styles/images/noleftchatimg.svg";
type MainContactPageState = {
  searchContacts: any;
  searchPinned:any;
  pinnedContacts:any;
  favouriteContacts:any;
  filterKey:string;
  isSearch:boolean;
  searchUnread:any;
  searchArchive:any;
  searchSaved:any;
  searchText:string;
  draftContacts: Array<any>;
  failedContacts:Array<any>;
  isUnread:boolean;
}

 function LeftsideBars() {
  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const tabReducer: any = useSelector((state: initialStateModel) => state.recentChatTabReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let {  contactReducer  } = allReducer;
  let workContact = contactReducer?.workContactsnew;
  let teamContact = contactReducer?.teamContacsnew;
  let socketTimeout = useRef<any>(null);
  const {recentChatList,savedChatList}: recentChatSocketReducerStateModel = 
  useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const history = useHistory();
  const recentArray = Object.values(recentChatList);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let {chatWindowDetails} = chatWindow;
  const workContacts = useSelector((state: initialStateModel) => state.contactReducer);
  const internetReducer = useSelector((state:any)=>state.internetReducer);
  const socketService = useRef<any>(null);
  const chatState = useRef<string>("RecentRecent");
  let refIndex = useRef<number>(0);
  let prevIndex = useRef<number>(0);
  let prevCurreIndex = useRef<number>(0);
  const [defaultContacts, setdefaultContacts] = useState<MainContactPageState>
  ({searchContacts:[],searchPinned:[],filterKey:"default",isSearch:false, searchUnread:[],
    searchArchive:[],searchSaved:[],searchText:"", pinnedContacts:[], favouriteContacts:[], draftContacts:[],failedContacts:[],isUnread:false});
    const toastUndo :any  = useSelector((state: any) => state.toastReducer);
  let {draftContact,failedContact} = contactList;
  let { isNewMessageWindow }: chatwindowDetails = store.getState().chatWindowReducer;
  const [mount, setMount] = useState<boolean>(false);
  const [isOpen, setOpen] = useState<boolean>(false);
  //const [isindex, setRefIndex] = useState<any>(0);
  const [recentAllList, setRecentallList] = useState<any>([]);
  useEffect(()=>{
    const userInfos:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess){
      const cookieData =JSON.parse(userInfosess);
      socketService.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    let sipid = loginDetails.userdetails.sip_login_id;
    var pinnedMessages = recentArray.filter((item:any) => item?.settings?.isPinned?.["s" + sipid]);
    var unpinnedMessages = recentArray.filter((item:any) => !item?.settings?.isPinned?.["s" + sipid]);
     var unpinnedMessages = _.chain(unpinnedMessages).sortBy((item:any) => {
      if(item?.lastmessage?.timestamp ||  item?.timestamp){
        return item?.lastmessage?.timestamp ? item?.lastmessage?.timestamp :item?.timestamp
      } else {
        return -1
      }
    }, ['desc']).reverse().flatten()
    .value();
    var resultOrder =  [...pinnedMessages, ...unpinnedMessages];
    // var result = _.chain(recentArray).sortBy((item:any) => {
    //   if(item?.lastmessage?.timestamp ||  item?.timestamp){
    //     return item?.lastmessage?.timestamp ? item?.lastmessage?.timestamp :item?.timestamp
    //   } else {
    //     return -1
    //   }
    // }, ['desc']).reverse().flatten()
    // .value();
    // var resultOrder = _.orderBy(result , [(elem:any) => elem?.settings?.isPinned["s"+sipid]], ['desc']);

  
    const all_list:Array<any> = [];
    const unreadCount:Array<any> = [];
    const archiveArray:Array<any> = [];
    const favArray:Array<any> = [];
    const pinnedContact:Array<any> = [];
      _.forEach(resultOrder, (value:any)=> {
      if(
      value?.settings?.isArchive?.["s"+sipid]===0 && 
      value?.settings?.isDeleted?.["s"+sipid]===0){
        all_list.push(value);
      }
      if((value?.unreadCount>0 &&value?.settings?.isDeleted?.["s"+sipid]===0) || (value?.unreadCount === 0 && value?.settings?.markRead["s" + sipid] === 2)){
        unreadCount.push(value);
      }
      if((value?.settings && 
        (value?.settings?.isArchive && value?.settings?.isArchive["s"+sipid]===1 
        && value?.settings?.isDeleted["s"+sipid]===0 ))){
        archiveArray.push(value);
      }
      if((value?.settings && 
        (value?.settings?.isFavourite && value?.settings?.isFavourite["s"+sipid]===1&& value?.settings?.isDeleted?.["s"+sipid]===0))){
          favArray.push(value);
        }
        
        if(value?.settings && value?.settings?.isPinned && value?.settings?.isPinned["s"+sipid] && 
        (!value?.settings?.isArchive || !(value?.settings?.isArchive["s"+sipid]) || (value?.settings?.isArchive["s"+sipid])===0) ){
          pinnedContact.push(value);
        }

      //   if(value.unreadCount >0){
      //   let filterNotify:any = _.filter(unreadCount, ((data: any) => {
      //       let type = data?.lastmessage?.message;
      //       return (type?.messageType === "TASK" || type?.messageType === "NOTE" || type?.messageType === "EVENTS");
      //   }));
      //     if(filterNotify?.length >0){
      //       notificationDataServer(filterNotify);
      //     }
      // }
        
    });
    
    if(defaultContacts?.searchText === ""){
      setRecentallList(all_list);
      setdefaultContacts({...defaultContacts, searchContacts:all_list, 
        searchUnread: unreadCount, pinnedContacts:pinnedContact,searchText:"",
        searchArchive: archiveArray, favouriteContacts:favArray, draftContacts: draftContact});
    }
      document.addEventListener("keydown", keyDownEvent);
      return () =>  document.removeEventListener("keydown", keyDownEvent);
   },[JSON.stringify(recentChatList),mount, isOpen,internetReducer]);
 
  const searchRecentChat = (e:any, value?:any)=>{
    let searchText:string = e?.target?.value?.toLowerCase() ? e?.target?.value?.toLowerCase():   value ? value: "";
    let sipid = loginDetails.userdetails.sip_login_id;
    var result = _.chain(recentArray).sortBy((item:any) => {
      if(item?.lastmessage?.timestamp ||  item?.timestamp){
        return item?.lastmessage?.timestamp ? item?.lastmessage?.timestamp :item?.timestamp
      } else {
        return -1
      }
    }, ['desc']).flatten().reverse()
    .value();
    var resultOrder = _.orderBy(result , [(elem:any) => elem?.settings?.isPinned["s"+sipid]], ['desc']);
    var resultup =  _.filter(resultOrder, (value:any)=> 
    (
    value?.settings?.isArchive?.["s"+sipid]===0 && 
    value?.settings?.isDeleted?.["s"+sipid]===0));

    var pinnedContacts =_.filter(resultOrder, (contacs:any) => {
      if(contacs?.settings && contacs?.settings?.isPinned && contacs?.settings?.isPinned["s"+sipid]){
        return contacs;
      }
    });
    var favouriteContacts =_.filter(resultOrder, (contacs:any) => {
      return(contacs?.settings && contacs?.settings?.isFavourite && contacs?.settings?.isFavourite["s"+sipid]===1);
    });
    if(defaultContacts.filterKey==="Unread"){
      let filtered_array = _.filter(resultOrder, ({unreadCount}) => unreadCount > 0);

      const searchResponse =  SearchRecentSocketChat(filtered_array,searchText);
      setdefaultContacts({...defaultContacts,  searchUnread:searchResponse,
        isSearch:true,searchText:searchText});
    } else if(defaultContacts.filterKey==="Draft"){
    
      let filtered_array = _.filter(draftContact, (value) => value?.contactDetail?.caller_id?.toLowerCase().indexOf(searchText)>-1 
      || value?.contactDetail?.team_name?.toLowerCase().indexOf(searchText)>-1);
      setdefaultContacts({...defaultContacts,  draftContacts:filtered_array,
        isSearch:true,searchText:searchText});
    } else  if(defaultContacts.filterKey==="Archive"){
      let filtered_array = _.filter(resultOrder, (contacs:any)=>(contacs?.settings && 
        (contacs?.settings?.isArchive && contacs?.settings?.isArchive["s"+sipid]===1)));
      const searchResponse =  SearchRecentSocketChat(filtered_array,searchText);
      setdefaultContacts({...defaultContacts,  searchArchive:searchResponse,
        isSearch:true,searchText:searchText});
    } else {
      const searchResponse =  SearchRecentSocketChat(resultup,searchText);
      const searchFavResponse =  SearchRecentSocketChat(favouriteContacts,searchText);
      if(value!==""){
        setRecentallList(searchResponse);
        setdefaultContacts({...defaultContacts, searchContacts:searchResponse, 
          isSearch:true,searchText:searchText,pinnedContacts:pinnedContacts, favouriteContacts:searchFavResponse});
      } else {
        setRecentallList(searchResponse);
        setdefaultContacts({...defaultContacts, searchContacts:searchResponse, 
          isSearch:true,searchText:"",pinnedContacts:pinnedContacts, favouriteContacts:searchFavResponse});
      }
     
    }
    
  };
  const unArchive = (data:any) =>{
    let chatDetails = {
      chatId : data.chatId,
      settingsKey : "isArchive",
      status : 0
    }
    const originalArchive = defaultContacts.searchArchive;
    const tempArchive = [...defaultContacts.searchArchive];
    const index = originalArchive.findIndex((value:any)=>value?.chatId === data?.chatId);

    const timer = setTimeout(()=>{socketService.current.updateRecentChatSettings(chatDetails);
      originalArchive.splice(index,1);
      setdefaultContacts({...defaultContacts,  searchArchive:originalArchive,
        isSearch:true,searchText:''}); 
      socketService.current.toastUndo("","")},3000);
    socketTimeout.current = tempArchive;
    socketService?.current?.toastUndo("Chat Unarchived",timer);
  };
  

   const initialOpenWindow = (internet: boolean =false) =>{
    const userDetailsnew = userInfo();
    const currUser = parseInt(userDetailsnew.fromID);
    let sipid = loginDetails?.userdetails?.sip_login_id;
    if(sipid){
    var result:any = _.chain(recentArray).sortBy((item:any) => {
      if(item?.lastmessage?.timestamp ||  item?.sorceTimestamp){
        return item?.lastmessage?.timestamp ? item?.lastmessage?.timestamp :item?.sorceTimestamp
      } else {
        return -1
      }
    }, ['desc']).filter((value:any)=>{
      return value?.settings?.isPinned?.["s"+sipid]===0 && 
      value?.settings?.isArchive?.["s"+sipid]===0 && 
      value?.settings?.isDeleted?.["s"+sipid]===0
    }).reverse().flatten()
    .value();
    if(Array.isArray(result) && result.length>0){
      if(result[0].type===1 && chatWindowDetails && Object.keys(chatWindowDetails).length===0){
        if(_.isUndefined(result[0]?.users?.["s"+currUser])===false && 
        _.isUndefined(workContacts.workContactsnew?.[result[0]?.users?.["s"+currUser]])===false && 
         (!mount || internet)){
          const toUser = workContacts.workContactsnew?.[result[0]?.users?.["s"+currUser]];
          let chatDetail ={chatId:generateChatID(userInfo().fromID, chatWindowDetails?.sip_login_id ? chatWindowDetails?.sip_login_id :toUser?.sip_login_id )};
          if(socketService?.current && !isNewMessageWindow){
          socketService?.current?.openChatWindow(chatWindowDetails?.sip_login_id ? chatWindowDetails:workContacts.workContactsnew?.[result[0]?.users["s"+currUser]],history,chatDetail)
           setMount(true);
          } else if(isNewMessageWindow) {
            setMount(true);
          }
        }
      }else if(result[0].type===2 && chatWindowDetails && Object.keys(chatWindowDetails).length===0) {
        if(_.isUndefined(workContacts.teamContacsnew?.["con"+result[0]?.chatId])===false 
         && (!mount || internet) && chatWindowDetails && Object.keys(chatWindowDetails).length===0){
          if(socketService?.current && !isNewMessageWindow){
          socketService?.current?.openChatWindow(chatWindowDetails?.team_id ? chatWindowDetails: workContacts.teamContacsnew?.["con"+result[0]?.chatId],history)
          setMount(true);
          }else if(isNewMessageWindow){
            setMount(true);
          }
        }
       
      }
      if(!isOpen){
        if(chatWindowDetails?.sip_login_id){
          const userInfos:any =Cookie.get();
          const userInfosess: any = sessionStorage.getItem("userinfo");
          const cookieData =JSON.parse(userInfosess);
          const toUser = workContacts.workContactsnew?.[chatWindowDetails?.sip_login_id];
          if(parseInt(toUser?.sip_login_id) !== parseInt(cookieData?.sip_login_id)){
          let chatDetail ={chatId:generateChatID(userInfo().fromID, chatWindowDetails?.sip_login_id ? chatWindowDetails?.sip_login_id :toUser?.sip_login_id )};
          socketService?.current?.openChatWindow(toUser,history,chatDetail)
          setOpen(true);
         }
        }
        else if(chatWindowDetails?.team_id){
          const toUser = workContacts.teamContacsnew?.["con"+chatWindowDetails?.team_id];
          if(toUser){
          socketService?.current?.openChatWindow(toUser);
          setOpen(true);
        }
        }
        
      }
      // 
    }
  }
   }

   const keyDownEvent = (e:any) => {
    let { isNewMessageWindow }: chatwindowDetails = store.getState().chatWindowReducer;
     if(chatState.current){
     let index = refIndex.current;
     const userDetails = userInfo();
     let sipid = loginDetails?.userdetails?.sip_login_id;
     const pinnedContact:any = [];
     const favArray:any = [];
     var updatedrecentArray:any = _.chain(recentArray).sortBy((item:any) => item?.lastmessage?.timestamp, ['desc']).filter((value:any)=>{
      if((value?.settings && 
        (value?.settings?.isFavourite && value?.settings?.isFavourite["s"+sipid]===1&& value?.settings?.isDeleted?.["s"+sipid]===0))){
          favArray.push(value);
        }
        if(value?.settings && value?.settings?.isPinned && value?.settings?.isPinned["s"+sipid] && 
        (!value?.settings?.isArchive || !(value?.settings?.isArchive["s"+sipid]) || (value?.settings?.isArchive["s"+sipid])===0) ){
          pinnedContact.push(value);
        }
      return value?.settings?.isPinned?.["s"+sipid]===0 && 
      value?.settings?.isArchive?.["s"+sipid]===0 && 
      value?.settings?.isDeleted?.["s"+sipid]===0
    }).reverse().valueOf();

     const updatedArray = updatedrecentArray.filter((value:any)=>{
      const contactDetail = value?.type===1? workContacts?.workContactsnew?.[value?.users?.["s"+userInfo().fromID]]:workContacts?.teamContacsnew?.["con"+value?.chatId];
       return contactDetail!==undefined;
     });
     var focusableInputElements:any = document.querySelectorAll("."+chatState.current);
    
     if(e.key==="Enter" && index>-1 && e.target.className.indexOf('Recent')>-1){
       if(chatState.current==="FavouriteRecent"){
         const updatedFavouriteContact = favArray.reverse();
         if(prevIndex.current>-1){
          focusableInputElements[prevIndex.current].removeAttribute('style');
         }
         if(updatedFavouriteContact[index]){
          const contactDetail = updatedFavouriteContact[index]?.type===1 ? workContacts?.workContactsnew?.[updatedFavouriteContact[index]?.users?.["s"+userInfo().fromID]]
          :workContacts?.teamContacsnew?.["con"+updatedFavouriteContact[index]?.chatId];
          focusableInputElements[index].removeAttribute('style');
          let chatId = {"chatId":generateChatID(userDetails.fromID,contactDetail?.sip_login_id)};
          
          if((updatedFavouriteContact[index]?.type===1 && chatWindowDetails?.sip_login_id!==contactDetail?.sip_login_id) || 
            (updatedFavouriteContact[index]?.type===2 && chatWindowDetails?.team_id!==contactDetail?.team_id)){
              prevIndex.current = index;
              socketService?.current?.openChatWindow(contactDetail, history,updatedFavouriteContact[index]?.type===1 ? chatId: "");
            }
         
         }
      
       }
       if(chatState.current==="PinnedRecent"){
         const updatedPinnedContact = pinnedContact.reverse();
        if(updatedPinnedContact[index]){
        const contactDetail = updatedPinnedContact[index]?.type===1 ? workContacts?.workContactsnew?.[updatedPinnedContact[index]?.users?.["s"+userInfo().fromID]]
        :workContacts?.teamContacsnew?.["con"+updatedPinnedContact[index]?.chatId];
        focusableInputElements[index].removeAttribute('style');
        let chatId = {"chatId":generateChatID(userDetails.fromID,contactDetail?.sip_login_id)};
        if((updatedPinnedContact[index]?.type===1 && chatWindowDetails?.sip_login_id!==contactDetail?.sip_login_id) || 
        (updatedPinnedContact[index]?.type===2 && chatWindowDetails?.team_id!==contactDetail?.team_id)){
        socketService?.current?.openChatWindow(contactDetail, history,updatedPinnedContact[index]?.type===1 ? chatId: "");
        prevIndex.current = index;
        }
      }
      }
      if(chatState.current==="RecentRecent" && updatedArray[index]){
        const contactDetail = updatedArray[index]?.type===1 ? workContacts?.workContactsnew?.[updatedArray[index]?.users?.["s"+userInfo().fromID]]
        :workContacts?.teamContacsnew?.["con"+updatedArray[index]?.chatId];
        focusableInputElements[index].removeAttribute('style');
        let chatId = {"chatId":generateChatID(userDetails.fromID,contactDetail?.sip_login_id)};
        if((updatedArray[index]?.type===1 && chatWindowDetails?.sip_login_id!==contactDetail?.sip_login_id) || 
        (updatedArray[index]?.type===2 && chatWindowDetails?.team_id!==contactDetail?.team_id)){
        socketService?.current?.openChatWindow(contactDetail, history,updatedArray[index]?.type===1 ? chatId: "");
        prevIndex.current = index;
        }
      }
     }
      if(e.key === 'ArrowDown' && !isNewMessageWindow && focusableInputElements && refIndex.current>-1 && focusableInputElements[refIndex.current+1]) {
        const refIndexD = refIndex.current + 1; 
        if(refIndexD >= 1){
          focusableInputElements[refIndexD-1]?.removeAttribute('style');
        }
        focusableInputElements[refIndexD].focus();
        focusableInputElements[refIndexD].style.backgroundColor =(prevCurreIndex.current !== refIndexD)?"#DCF5EE": "#161717"
        focusableInputElements[refIndexD].style.outline  = "none";
        refIndex.current = refIndexD;
      } else if(e.key === 'ArrowUp' && !isNewMessageWindow && refIndex.current>=1 && focusableInputElements[refIndex.current - 1]) {
        
        const refIndexD = refIndex.current - 1;
          focusableInputElements[refIndexD+1].removeAttribute('style');
          focusableInputElements[refIndexD].focus();
          focusableInputElements[refIndexD].style.backgroundColor = (prevCurreIndex.current !== refIndexD)?"#DCF5EE": "#161717"
          focusableInputElements[refIndexD].style.outline  = "none";
          refIndex.current = refIndexD;
        }
    }
    }
 
 useEffect(()=>{
  setdefaultContacts({...defaultContacts,  draftContacts: draftContact});

 },[draftContact]);



 useEffect(()=>{
  if(toastUndo.undo && socketTimeout.current){
  setdefaultContacts({...defaultContacts, isSearch:true,searchText:''});
  socketTimeout.current = null;
  const chatSocket = new SocketChatService(userInfo().fromID,userInfo().domainId);
  chatSocket.toggleUndo(false);
  }
   },[toastUndo]);

  const workContactsList = async () => {
    if(workContacts?.workContactsnew!==null){
      if((mount || internetReducer?.internet===false || internetReducer?.navigation)
      && await Object.keys(workContacts?.workContactsnew).length>0 &&
      await Object.keys(workContacts?.teamContacsnew).length>0){
        setMount(false);
        if(!loginDetails?.landingPage){
           // initialOpenWindow(true);
        }
      }
    }else{
      window.location.reload();
    }
  };

   useEffect(()=>{
    workContactsList();
   },[internetReducer,workContacts?.workContactsnew,workContacts?.teamContacsnew]);
 const updateChatIndex = (index:any, chats:any) =>{
   refIndex.current = index;
   chatState.current = chats;
   var focusableInputElements:any = document.querySelectorAll("."+chatState.current);
   focusableInputElements[index]?.removeAttribute('style');
  // setRefIndex(refIndex.current);
   prevCurreIndex.current =  refIndex.current;
  if(defaultContacts.isSearch){
    //searchRecentChat("","");
    // setdefaultContacts({...defaultContacts,
    //   isSearch:false,searchText:""});
  }
 };

  const setMySpace=()=>{
    
    let mySpaceDetials:any =loginDetails.userdetails;

   
    mySpaceDetials.isMySpace = true;
    mySpaceDetials.jid = `${mySpaceDetials.sip_login_id}@${mySpaceDetials.host_address}`;
    ChatService.openChatWindow(mySpaceDetials);
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    socketChat.getChatHistory(`chat${userInfo().fromID}${userInfo().fromID}${userInfo().domainId}`,"")
    
    ChatService.emptyOnMyspace();
    ChatService.editDraft("");
    chat_reducer.isWindowSlide && chatSideWindow(false, "", {});
    store.dispatch({
      type: Types.TAB_CHANGE,
      payload: {
        ActiveTab: '1'
      }
    });
  };

  const setFilteredLayer = (filtelayer:string)=>{
    console.log(filtelayer,"filtelayer")
    setdefaultContacts({...defaultContacts,filterKey:filtelayer,isUnread:false});
  };
  const unReadChat = ()=>{
    if(!defaultContacts?.isUnread){
      setdefaultContacts({...defaultContacts,filterKey:"Unread",isUnread:!defaultContacts?.isUnread});
      //setRecentallList(filteredContacts);
    } else {
     // setRecentallList(defaultContacts?.searchContacts);
      setdefaultContacts({...defaultContacts,filterKey:"default",isUnread:!defaultContacts?.isUnread});
    }
   
   
  }


  return (
    <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
       
          {/* {(!chat_reducer.notifyPermission || !chat_reducer.audioPermission || !chat_reducer.videoPermission) && <div className={styles.notificationtop}><NotificationBottom /></div>} */}
          {( workContacts.jenkinMessage) && <div className={styles.notificationtop}><NotificationBottom  /></div>}
        <Searchbox searchRecentChat={searchRecentChat} searchText={defaultContacts.searchText} unReadChat={unReadChat} isUnread={defaultContacts?.isUnread}></Searchbox>
       
        {defaultContacts.filterKey === "default" && <>
        <div className={`leftmyspace ${styles.mySpaceleft}  ${chatWindowDetails?.isMySpace ? styles.active : ""}`} onClick={setMySpace}>
          {loginDetails?.userdetails?.user_status  === "Available" ||
          loginDetails?.userdetails?.user_status ==='Active' ?
                
            <div className="mySpaceDot bgGreen" ></div>:
            loginDetails.userdetails.user_status === "Busy"
              ? <div className="mySpaceDot bgYello" ></div>
              : loginDetails.userdetails.user_status === "Do not disturb"
                ? <div className="mySpaceDot bgRed" ></div>
               
                : <div className="mySpaceDot bgGrey" ></div>
          }
          <span className={styles.mySpaceuserName}>{loginDetails?.userdetails?.caller_id}</span> <label className={styles.myspaceText}>(My Space)</label></div>
            <div className={`leftsidebarScroll scrollerhover ${styles.leftScrolldiv}  }`}>
       {/* {(defaultContacts.searchArchive?.length> 0 || defaultContacts.searchUnread?.length >0 || defaultContacts.draftContacts?.length >0 || failedContact?.length > 0 || savedChatList?.length >0) &&  */}
       <Filterlayer searchArchive={defaultContacts.searchArchive} 
          unreadContacts={defaultContacts.searchUnread} 
          draftContact={defaultContacts.draftContacts}
          setFilteredLayer={setFilteredLayer} failedContact={failedContact}
          ></Filterlayer> 
          {/* } */}
          {/* {Array.isArray(defaultContacts?.pinnedContacts) && defaultContacts?.pinnedContacts.length>0 && <Pinchats chats={"Pinned"}  defaultContacts={defaultContacts} updateChatIndexData={updateChatIndex} ></Pinchats>} */}
          {Array.isArray(defaultContacts?.favouriteContacts) && defaultContacts?.favouriteContacts.length>0 && <Favouritechats chats={"Favourite"}  defaultContacts={defaultContacts} updateChatIndexData={updateChatIndex}></Favouritechats>}
          {defaultContacts.searchContacts.length===0 && internetReducer.navigation === true &&
            <NoContent image={noResult}
              title={''}
              description={'Loading...'} />}
          {recentAllList.length===0 && internetReducer.navigation === false && !defaultContacts?.isUnread &&
            <NoContent image={noResultSearch}
              title={''}
              description={'No results found'} />}
          {recentAllList.length>0 &&  
            <Recentchats chats={"Recent"} defaultContacts={defaultContacts} updateChatIndexData={updateChatIndex} recentAllList={recentAllList}></Recentchats>}
        
            </div>
          </>}
       {/* { (defaultContacts.searchArchive?.length> 0 || defaultContacts.searchUnread?.length >0 || defaultContacts.draftContacts?.length >0 || failedContact?.length > 0 || savedChatList?.length >0) &&   */}
          <div className={styles.filteractions}>
          {defaultContacts.filterKey === "Unread" && <UnreadContactLists chats={"Unread"}   defaultContacts={defaultContacts}
          updateChatIndex={updateChatIndex}
            setFilteredLayer={setFilteredLayer}/>}
          {defaultContacts.filterKey === "Saved" &&<SavedChatListsLeft  defaultContacts={defaultContacts}
            setFilteredLayer={setFilteredLayer}/>}
          {defaultContacts.filterKey === "Draft" &&<DraftListsLeft draftContacts={defaultContacts.draftContacts} setFilteredLayer={setFilteredLayer}/>}
          {defaultContacts.filterKey === "Failed" &&<FailedListsLeft  setFilteredLayer={setFilteredLayer}/>}
          {defaultContacts.filterKey === "Archive" &&<ArchieveLists  chats={"Archive"}
          updateChatIndexData={updateChatIndex} 
          unArchive={unArchive}
          defaultContacts={defaultContacts}
            setFilteredLayer={setFilteredLayer}/>}
        </div>
        {/* } */}
            
      </div> 
    </>
  );
};

export default React.memo(LeftsideBars)